export default {
  toasts: {
    failed_to_delete_website: 'Eroare la ștergerea site-ului',
    website_deleted: 'Site-ul a fost șters',
  },
  delete_model: {
    title: 'Sigur doriți să ștergeți site-ul?',
    confirm: 'Șterge',
    cancel: 'Anulează',
  },
  buttons: {
    open_editor: 'Deschide editorul',
    transfer_website: 'Transferă site',
    delete_site: 'Șterge',
  },
};
